import axios from '../../axios-atis'

import * as actionTypes from './actionTypes';
import {logout} from './index';

export const fetchUsersBegin = () => ({
    type : actionTypes.FETCH_USERS_BEGIN
});

export const fetchUsersSuccess =  users  => {
    return {
        type: actionTypes.FETCH_USERS_SUCCESS,
        payload: { users }
    }
};

export const fetchUsersError = error => {
    return {
        type: actionTypes.FETCH_USERS_FAILED,
        payload: { error }
    };
};

export const fetchUsers = (page, pageSize, filtred, sorted) => {
    return dispatch => {
        dispatch(fetchUsersBegin());
        let url = '/users';
        axios.get(url)
            .then(response => {
                dispatch(fetchUsersSuccess(response.data));
            })
            .catch(err => {
                dispatch(fetchUsersError(err));
            });
    };
};

export const fetchUserBegin = () => ({
    type : actionTypes.FETCH_USER_BEGIN
});

export const fetchUserSuccess =  user  => {
    return {
        type: actionTypes.FETCH_USER_SUCCESS,
        payload: { user }
    }
};

export const fetchUserError = error => {
    return {
        type: actionTypes.FETCH_USER_FAILED,
        payload: { error }
    };
};

export const fetchUser = () => {
    var userId = localStorage.getItem('userId');
    if (userId) {
        return dispatch => {
            dispatch(fetchUsersBegin());
            let url = '/users/' + userId;
            axios.get(url)
                .then(response => {
                    dispatch(fetchUserSuccess(response.data));
                })
                .catch(err => {
                    dispatch(fetchUserError(err));
                });
        };
    } else {
        return dispatch => { dispatch(logout())};
    }
};

export const updateUserSuccess =  user  => {
    return {
        type: actionTypes.UPDT_USER_SUCCESS,
        payload: { user }
    }
};

export const updateUserError = error => {
    return {
        type: actionTypes.UPDT_USER_FAILED,
        payload: { error }
    };
};
export const updateUser = (user) => {
    var userId = localStorage.getItem('userId');
    if (userId && parseInt(userId,10)===user.id) {
        return dispatch => {
            dispatch(fetchUsersBegin());
            let url = '/users/' + userId;
            axios.post(url, user)
                .then(response => {
                    dispatch(updateUserSuccess(response.data.result));
                })
                .catch(err => {
                    dispatch(updateUserError(err));
                });
        };
    } else {
        return dispatch => { dispatch(logout())};
    }
};


export const addUserBegin = () => ({
  type: actionTypes.ADD_USER_BEGIN
});

export const addUserSuccess = user => {
  return {
    type: actionTypes.ADD_USER_SUCCESS,
    payload: { user }
  }
};

export const addUserError = error => {
  return {
    type: actionTypes.ADD_USER_FAILED,
    payload: { error }
  };
};

export const addUser = (user) => {
  return dispatch => {
    dispatch(addUserBegin());
    const url = '/users';
    axios.post(url, user)
      .then(response => {
        if (response.data.status == 201) {
          dispatch(addUserSuccess(response.data));
        } else {
          dispatch(addUserError(response.data));
        }
      })
      .catch(err => {
        dispatch(addUserError(err));
      });
  };
};


// WEBPACK FOOTER //
// ./src/store/actions/user.js